import SiafLiteImpressoraApi from "../../external/siaf-lite-impressora-api";

class ImpressoraService {
  constructor() {}

  imprimir(body) {
    return new SiafLiteImpressoraApi("/impressora/etiqueta").post(body);
  }

  imprimirTermica(body) {
    return new SiafLiteImpressoraApi("/impressora/fiscal").post(body);
  }

  imprimirTermicaPdf(body) {
    return new SiafLiteImpressoraApi("/impressora/pdf").post(body);
  }

  get(body) {
    return new SiafLiteImpressoraApi("/impressora").get(body);
  }
}

export default ImpressoraService;
